@if (label) {
  <legend [ngClass]="{'required':required}"
    [attr.for]="fieldId">{{label| translate}}
  </legend>
}
@if (controlStatus | async; as status) {
  <div class="input-component"
    [formGroup]="formGroup"
    [style.height.px]="componentHeight"
    [style.marginTop.px]="marginTop"
    [class.pristine]="!status.dirty"
    [class.valid]="!status.invalid"
    [class.invalid]="status.invalid"
    [class.required]="required">
    <div class="input-wrapper"
      [style.height.px]="wrapperHeight">
      @if (lineSize === 0) {
        <div class="checkbox-group"
          [ngClass]="orientation"
          [attr.disabled]="isDisabled ? '' : null">
          @for (so of options; track so) {
            <div class="checkbox"
              >
              <aa-checkbox9 [option]="so"
                [name]="ctrlName">
              </aa-checkbox9>
            </div>
          }
        </div>
      }
      @if (lineSize !== 0) {
        <div class="checkbox-group"
          [attr.disabled]="isDisabled ? '' : null"
          [style.marginTop.px]="marginTop">
          <table>
            @for (line of lines; track line; let i = $index) {
              <tr>
                @for (so of options.slice(i * lineSize, (i + 1) * lineSize); track so) {
                  <td>
                    <aa-checkbox9 [option]="so"
                      [name]="ctrlName">
                    </aa-checkbox9>
                  </td>
                }
              </tr>
            }
          </table>
        </div>
      }
      <aa-check-mark9 [status]="status">
      </aa-check-mark9>
    </div>
    <aa-field-msg-error [status]="status">
    </aa-field-msg-error>
  </div>
}
